import { createContext, Dispatch, FC, useMemo, useReducer } from 'react';
import { noop } from 'lodash';

import { SearchRecordDto } from '../constants';

interface ModalState {
  isOpen: boolean;
  record: SearchRecordDto | null;
}

type ModalAction =
  | {
      type: 'OPEN_MODAL';
      payload: SearchRecordDto;
    }
  | { type: 'CLOSE_MODAL' };

interface ModalProviderProps {
  initialStateOverride?: Partial<ModalState>;
}

const initialState: ModalState = {
  isOpen: false,
  record: null,
};

const reducer = (state: ModalState, action: ModalAction): ModalState => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        ...state,
        isOpen: true,
        record: action.payload,
      };
    case 'CLOSE_MODAL':
      return initialState;
    default:
      return state;
  }
};

export const DashboardSearchModalContext = createContext<{
  state: ModalState;
  dispatch: Dispatch<ModalAction>;
}>({
  state: initialState,
  dispatch: noop,
});

export const DashboardSearchModalProvider: FC<ModalProviderProps> = ({
  initialStateOverride = {},
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...initialStateOverride,
  });

  const value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <DashboardSearchModalContext.Provider value={value}>
      {children}
    </DashboardSearchModalContext.Provider>
  );
};
